import '/app/brewery-packages/content/content-editor-plugin-title/src/Title.css-raw';
export default {
  "title": "employees-21b62107-title--87Tha"
};